import type { SVGProps } from "react";
const SvgDocker = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 256 256"
    {...props}
  >
    <rect width="100%" height="100%" fill="#fff" />
    <path
      fill="#1D63ED"
      d="M240.226 111.187c-5.689-3.827-20.634-5.461-31.497-2.534-.583-10.815-6.168-19.93-16.376-27.885l-3.778-2.534-2.518 3.803c-4.951 7.51-7.038 17.518-6.3 26.616.583 5.606 2.532 11.905 6.3 16.477-14.141 8.198-27.178 6.337-84.907 6.337H12.02c-.259 13.028 1.835 38.086 17.78 58.486a72 72 0 0 0 5.789 6.534C48.553 209.46 68.141 218.976 97.431 219c44.685.041 82.968-24.099 106.258-82.462 7.662.124 27.892 1.372 37.793-17.745.241-.321 2.518-5.068 2.518-5.068l-3.774-2.534zM70.187 99.275H45.124v25.048h25.063zm32.377 0H77.501v25.048h25.063zm32.38 0h-25.063v25.048h25.063zm32.38 0h-25.063v25.048h25.063zm-129.517 0H12.744v25.048h25.063zm32.38-31.636H45.124v25.048h25.063zm32.377 0H77.501v25.048h25.063zm32.38 0h-25.063v25.048h25.063zm0-31.639h-25.063v25.048h25.063z"
    />
  </svg>
);
export default SvgDocker;
